module.exports = __webpack_public_path__ + "/images/ico-app-store.9f570b3.svg";